// extracted by mini-css-extract-plugin
export default {"root":"signUpBanner__root__nSGRa","sticky":"signUpBanner__sticky__p6Evd"};